<template>
  <div class="main table-box">
    <global-tag>
      <el-form label-width="100px" :model="queryInfo">
        <div class="searchBox">
          <div class="content">
            <el-row>
              <el-col :span="5">
                <el-form-item label="姓名：">
                  <el-input
                    clearable
                    v-model.trim="queryInfo.personName"
                    style="width: 100%"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="性别：">
                  <el-select
                    style="width: 100%"
                    v-model="queryInfo.personSex"
                    placeholder="性别"
                  >
                    <el-option label="男" value="1"></el-option>
                    <el-option label="女" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="联系方式：">
                  <el-input
                    clearable
                    v-model.number="queryInfo.personPhone"
                    style="width: 100%"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="机构点：">
                  <el-select
                    style="width: 100%"
                    v-model="queryInfo.serviceStationId"
                    placeholder="服务类型"
                  >
                    <el-option
                      v-for="item in serviceList"
                      :key="item.id"
                      :label="item.statName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="身份证号码：">
                  <el-input
                    clearable
                    v-model="queryInfo.personIdentity"
                    style="width: 100%"
                    placeholder="请输入身份证号码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5" :offset="7">
                <el-button
                  type="primary"
                  @click="querySearch"
                  class="searchBtns"
                  >查询
                </el-button>
                <el-button
                  type="info"
                  icon="el-icon-delete"
                  @click="emptySearch"
                  >清除条件
                </el-button>
              </el-col>
              <el-col :span="4"></el-col>
            </el-row>
          </div>
          <div class="btn"></div>
        </div>
      </el-form>
    </global-tag>
    <div class="table_title">
      <div class="btn_group">
        <el-button
          type="success"
          class="button openBtns"
          size="medium"
          @click="addServices('新增', 'add')"
          >新增
        </el-button>
      </div>
      <!-- 筛选按钮 -->
      <div class="screen_container">
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            class="dropRests"
            @click="reset"
          ></el-button>
          <!-- <el-button type="primary" style="padding: 10px 20px"> -->
          <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
            <span class="el-dropdown-link">
              <i class="el-icon-s-grid el-icon--right" style="color: #fff"></i>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="table_checkbox">
              <el-dropdown-item>
                <el-checkbox-group
                  v-model="tableChekbox"
                  @change="tableChekboxChange"
                >
                  <el-checkbox label="序号"></el-checkbox>
                  <br />
                  <el-checkbox label="姓名"></el-checkbox>
                  <br />
                  <el-checkbox label="性别"></el-checkbox>
                  <br />

                  <el-checkbox label="手机号码"></el-checkbox>
                  <br />

                  <el-checkbox label="年龄"></el-checkbox>
                  <br />

                  <el-checkbox label="地址"></el-checkbox>
                  <br />
                  <el-checkbox label="机构点"></el-checkbox>
                  <br />
                  <el-checkbox label="创建人"></el-checkbox>
                  <br />
                  <el-checkbox label="操作"></el-checkbox>
                  <br />
                </el-checkbox-group>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- </el-button> -->
        </el-button-group>
      </div>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="{
          background: '#e6e6e6',
          color: '#000',
        }"
        border
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          v-if="this.tempTableChekbox.findIndex((item) => item == '序号') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="姓名"
          align="center"
          prop="personName"
          v-if="this.tempTableChekbox.findIndex((item) => item == '姓名') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          label="性别"
          align="center"
          v-if="this.tempTableChekbox.findIndex((item) => item == '性别') != -1"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.personSex == 1">男</span>
            <span v-if="scope.row.personSex == 2">女</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号码"
          align="center"
          prop="personPhone"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '手机号码') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="年龄"
          align="center"
          prop="personAge"
          v-if="this.tempTableChekbox.findIndex((item) => item == '年龄') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="地址"
          align="center"
          prop="address"
          v-if="this.tempTableChekbox.findIndex((item) => item == '地址') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="机构点"
          align="center"
          prop="serviceStationName"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '机构点') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="创建人"
          align="center"
          prop="createName"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '创建人') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="200px"
          v-if="this.tempTableChekbox.findIndex((item) => item == '操作') != -1"
        >
          <template slot-scope="scope">
            <span @click="addServices('详情', scope.row)" class="operBtn"
              >查看</span
            >
            <span @click="addServices('编辑', scope.row)" class="operBtn"
              >编辑</span
            >
            <span @click="deleteItem(scope.row)" class="operBtn">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :page-size="pageOne.pageSize"
        :current-page.sync="pageOne.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageOne.total"
        @size-change="handletableDataSize"
        @current-change="handleTableDataChange"
      ></el-pagination>
    </div>
    <add-service
      v-if="serviceState"
      :openData="serviceInfo"
      @cancleService="cancleService"
    ></add-service>
  </div>
</template>
<script>
import addService from "./components/addService"

export default {
  name: "serviceMange",
  inject: ["reload"], //注入
  components: { addService },
  data() {
    return {
      pageOne: { total: 0, pageSize: 10, pageNo: 1 },
      tableData: [],
      queryInfo: {
        personName: "",
        personSex: "",
        personPhone: "",
        serviceStationId: "",
        personIdentity: "",
      },
      serviceState: false,
      serviceInfo: {},
      serviceList: [],
      tempTableChekbox: [
        "序号",
        "姓名",
        "性别",
        "手机号",
        "年龄",
        "地址",
        "机构点",
        "创建人",
        "操作",
      ],
      tableChekbox: [
        "序号",
        "姓名",
        "性别",
        "手机号",
        "年龄",
        "地址",
        "机构点",
        "创建人",
        "操作",
      ],
    }
  },
  created() {
    this.getList()
    this.serveData()
  },
  methods: {
    emptySearch() {
      this.queryInfo.personName = ""
      this.queryInfo.personSex = ""
      this.queryInfo.personPhone = ""
      this.queryInfo.serviceStationId = ""
      this.queryInfo.personIdentity = ""
      this.getList()
    },
    // 机构点信息
    serveData() {
      this.$http
        .request({
          url: "ypt/admin/serviceStation/info/findList",
          method: "POST",
          data: { pageNo: 1, pageSize: 1000 },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.serviceList = []
              return
            }

            this.serviceList = res.content.list
          }
        })
    },
    // 当前页
    handleTableDataChange(val) {
      this.pageOne.pageNo = val
      this.getList()
    },
    // 分页大小
    handletableDataSize(val) {
      this.pageOne.pageSize = val
      this.getList()
    },
    // 获取数据
    getList() {
      let params = {
        pageNo: this.pageOne.pageNo,
        pageSize: this.pageOne.pageSize,
        personName: this.queryInfo.personName,
        personSex: this.queryInfo.personSex,
        personPhone: this.queryInfo.personPhone,
        serviceStationId: this.queryInfo.serviceStationId,
        personIdentity: this.queryInfo.personIdentity,
      }
      this.$http
        .request({
          url: "/ypt/admin/serviceStaff/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.pageOne.total = 0
              return
            }
            this.tableData = res.content.list
            this.pageOne.total = res.content.count
          }
        })
    },
    //删除表格信息
    deleteItem(date) {
      let params = {
        id: date.id,
      }
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "/ypt/admin/serviceStaff/info/deleteById",
            method: "POST",
            data: params,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              // this.tableData = [];
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          })
      })
    },
    // 选择列的展示方式
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    // 取消新增、编辑、查看
    cancleService(state) {
      this.serviceState = false

      if (state == true) {
        this.getList()
      }
    },

    // 新增\编辑\查看
    addServices(title, row) {
      this.serviceState = true

      this.serviceInfo = {}
      this.serviceInfo = {
        title: title,
        id: title == "新增" ? "" : row.id,
        state: true,
      }
    },

    // 页面刷新
    reset() {
      this.reload()
    },
    // 搜索
    querySearch() {
      this.getList()
    },
  },
}
</script>
<style lang="less" scoped>
.searchBox {
  display: flex;

  .content {
    flex: 1;
  }
}

/deep/ .table_title {
  margin-top: 15px !important;
}

/deep/ .btn_group {
  margin-top: 0px !important;
}

.button {
  margin-bottom: 4px;
}

.labelImportBtn {
  background: orange;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 10px;
  font-size: 12px;
  padding: 0 17px;
  color: #fff;
  line-height: 28px;
  display: inline-block;
}

.operBtn {
  cursor: pointer;
  margin-left: 10px;
}

.el-table__body /deep/ .el-table__fixed {
  height: 100% !important; //设置高优先，以覆盖内联样式
}
</style>
